"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.store = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const notification_slice_1 = __importDefault(require("../reducers/notification/notification.slice"));
const authentication_slice_1 = __importDefault(require("../reducers/authentication/authentication.slice"));
const common_slice_1 = __importDefault(require("../reducers/common/common.slice"));
const user_slice_1 = __importDefault(require("../reducers/user/user.slice"));
const home_slice_1 = __importDefault(require("../reducers/home/home.slice"));
const profile_slice_1 = __importDefault(require("../reducers/profile/profile.slice"));
const knowledge_hub_slice_1 = __importDefault(require("../reducers/knowledge-hub/knowledge-hub.slice"));
const shalina_tv_slice_1 = __importDefault(require("../reducers/shalina-tv/shalina-tv.slice"));
const survey_slice_1 = __importDefault(require("../reducers/survey/survey.slice"));
const learning_center_slice_1 = __importDefault(require("../reducers/learning-center/learning-center.slice"));
const request_slice_1 = __importDefault(require("../reducers/request/request.slice"));
const community_slice_1 = __importDefault(require("../reducers/community/community.slice"));
const gamification_slice_1 = __importDefault(require("../reducers/gamification/gamification.slice"));
const partial_registration_slice_1 = __importDefault(require("../reducers/partial-registration/partial-registration.slice"));
// const middlewares: any = [
//   /* other middlewares */
// ];
// if (__DEV__) {
//   const createDebugger = require("redux-flipper").default;
//   middlewares.push(createDebugger());
// }
exports.store = (0, toolkit_1.configureStore)({
    reducer: {
        notification: notification_slice_1.default,
        authentication: authentication_slice_1.default,
        common: common_slice_1.default,
        user: user_slice_1.default,
        home: home_slice_1.default,
        profile: profile_slice_1.default,
        knowledgehub: knowledge_hub_slice_1.default,
        shalinatv: shalina_tv_slice_1.default,
        survey: survey_slice_1.default,
        learningCenter: learning_center_slice_1.default,
        request: request_slice_1.default,
        community: community_slice_1.default,
        gamification: gamification_slice_1.default,
        partialRegistration: partial_registration_slice_1.default,
    },
    // middleware: (getDefaultMiddleware) =>
    //   getDefaultMiddleware().concat(middlewares),
});
